import React from 'react';
import blog1 from '../images/datastructures.jpg';
import blog2 from '../images/selfbootcamp.png';
import blog3 from '../images/APIarticle.jpg';

const Blog = () => {
  const data = [
    {
      id: 1,
      img: blog2,
      datewritten: '11 April 2022',
      abbreviation: '',
      abbreviated_name: 'General',
      article_title: 'Self -Taught VS Boot-camp route',
      article_description: 'If you&apos;ve always wanted to venture into the tech industry I am sure you have at least once debated amongst yourself on which path will guarantee you the desired results.',
      article_link: 'https://nemwelb.medium.com/self-taught-vs-boot-camp-route-e44c98ed06e1',
    },
    {
      id: 2,
      img: blog1,
      datewritten: '21 June 2022',
      abbreviation: 'Data structures and Algorithms',
      abbreviated_name: 'DSA',
      article_title: 'Introduction to Data structures and algorithms',
      article_description: 'Data structures and algorithms. Sounds like an enigma, right? Luckily for you, my reader, today, I aim to debunk what these two mean by giving you a beginner-friendly overview of each and end it all with a simple example.',
      article_link: 'https://dev.to/nemwelboniface/data-structures-and-algorithms-277f',
    },
    {
      id: 3,
      img: blog3,
      datewritten: '22 August 2022',
      abbreviation: 'Application Programming interface',
      abbreviated_name: 'API',
      article_title: 'How to Create an API using Ruby on Rails 7 and PostgreSQL database',
      article_description: 'If you are new to programming like me I am sure that each time you come across this term you think of it as a very complex enigma to decipher.',
      article_link: 'https://dev.to/nemwelboniface/api-with-rails-7-ngh',
    },
  ];

  const displayBlogs = data.map(
    (element) => (
      <div key={element.id} className="myblog">
        <img src={element.img} alt={`${element.article_title}`} />
        <div className="blogbody">
          <div className="dategenre">
            <p className="date">{element.datewritten}</p>
            <p><abbr title={element.abbreviation}>{element.abbreviated_name}</abbr></p>
          </div>
          <h2>{element.article_title}</h2>
          <p>
            {element.article_description}
          </p>
          <a href={element.article_link} target="_blank" rel="noreferrer">Read more</a>
        </div>
      </div>
    ),
  );
  return (
    <div className="Blog" id="blogs">
      <div className="sectionHeading">
        <div className="sectionLeftHeading">
          <h3 className="headingPinked">My blogs</h3>
          <h2>What I have written</h2>
        </div>
        <div className="sectionRightMoreDetails">
          <a href="https://dev.to/nemwelboniface" target="_blank" rel="noreferrer">More articles</a>
        </div>
      </div>

      <div className="myblogs">
        {displayBlogs}
      </div>
    </div>
  );
};

export default Blog;
